module.exports = __webpack_public_path__ + "static/media/ic_searchtype_boatyard.29710c1c.svg";